export default {
  visitResults: [],
  layerTypes: [],
  layers: [],
  selectedLayer: {},
  selectedLayers: {},
  selectedLand: {},
  landGeometries: [],
  otherGeometries: {},
  lands: [],
  landsTotalCount: 0,
  selectedResident: {},
  residents: [],
  landResidents: [],
  landVisits: [],
  residentsTotalCount: 0
}
